import React, { Component } from "react";
import { Button, Card, CardGroup, Modal } from "react-bootstrap";
import { Checkbox } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import GeoJsonLayer from "./GeoJsonLayer";
import kanchanpur from "../../geojson/kanchanpur.json";
import { infastructure } from "../../variable/global";
// import kanchanpur from "../../geojson/bedkot.json";
import { MdPlace } from "react-icons/md";
import "leaflet/dist/leaflet.css";
import "../../assets/css/homePageDescription.scss";
import { connect } from "react-redux";

class MunicipalityDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            boundData: [],
            wholeGeojson: [],
            location: {
                lat: 27.938571,
                lng: 85.918619,
            },
            zoom: 11,
            checkbox: {},
            wholeGeoJSON: {},
            showGeoJSON: [],
            sectionTitle: "",
        };
    }
    // 	this.getMunicpalId = this.getMunicpalId.bind(this);
    // }

    // isGeoJsonAlreadyFetched = (field) => {
    // 	const { wholeGeoJSON } = this.state;
    // 	return Boolean(wholeGeoJSON[field]);
    // };

    // fetchGeoJSON = (changedData) => {
    // 	const body = {
    // 		industries: "institute/industries",
    // 		cultural_heritage: "institute/cultural_heritage",
    // 		gov_office: "institute/gov_office",
    // 		forest: "institute/forest",
    // 		offices: "institute/offices",
    // 		infrastructure: "institute/infrastructure",
    // 		economic: "institute/economic",
    // 		education: "institute/education",
    // 		security: "institute/security",
    // 		palika_related_office: "institute/palika_related_office",
    // 		public_places: "institute/public_places",
    // 		health: "institute/health",
    // 	};

    // 	return new Promise((resolve, reject) => {
    // 		Axios.get(`/api/geojson/${body[changedData]}`)
    // 			.then((result) => {
    // 				const wholeGeoJSON = this.state.wholeGeoJSON;
    // 				this.setState(
    // 					{
    // 						wholeGeoJSON: {
    // 							...wholeGeoJSON,
    // 							[changedData]: result.data,
    // 						},
    // 					},
    // 					() => resolve()
    // 				);
    // 			})
    // 			.catch((err) => reject());
    // 	});
    // };

    // arrangeAllOption = async () => {
    // 	const { checkbox } = this.state;

    // 	const showGeoJSON = [];
    // 	let dataToCheck = [];

    // 	dataToCheck = dataToCheck.concat(infastructure);
    // 	const data = dataToCheck.map(async (each, i) => {
    // 		if (checkbox[each.value]) {
    // 			if (!this.isGeoJsonAlreadyFetched(each.value))
    // 				await this.fetchGeoJSON(each.value);

    // 			showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
    // 		}
    // 	});
    // 	// wait until all promises resolve
    // 	await Promise.all(data);

    // 	this.setState({ showGeoJSON });
    // };

    // handleChange = (e) => {
    // 	e.persist();
    // 	this.setState(
    // 		({ checkbox }) => ({
    // 			checkbox: {
    // 				...checkbox,
    // 				[e.target.name]: e.target.checked,
    // 			},
    // 		}),
    // 		this.arrangeAllOption
    // 	);
    // };

    // style(feature) {
    // 	let skin = "blue";
    // 	if (feature.properties.FIRST_GaPa === "Bhimdatta") {
    // 		skin = "green";
    // 	}
    // 	return {
    // 		fillColor: skin,
    // 		weight: 1,
    // 		opacity: 1,
    // 		color: "black",
    // 		fillOpacity: 0.3,
    // 	};
    // }

    componentDidMount() {
        const boundData = [
            {
                key: "पुर्व",
                keyEnglish: "East",
                value: " रंगेली र बेलवारी न.पा",
                valueEnglish: "Rangeli and Belbari Municipality",
                class: "col-md-12",
            },
            {
                key: "उत्तर",
                keyEnglish: "North",
                value: "सुन्दर हरैंचा न.पा",
                valueEnglish: "Sundarharaicha Municipality",
                class: "col-md-12",
            },
            {
                key: "पश्चिम",
                keyEnglish: "West",
                value: "बुढीगंगा गा.पा",
                valueEnglish: "Budhiganga Rural Municipaliy ",
                class: "col-md-12",
            },
            {
                key: "दक्षिण",
                keyEnglish: "South",
                value: "विराटनगर म.न.पा. र कटहरी गा.पा.",
                valueEnglish: "Biratnagar Metropolitan and Katahari Rural Municipality",
                class: "col-md-12",
            },
            // {
            //     key: "क्षेत्रफल",
            //     keyEnglish: "Area",
            //     value: "११०.१६ ( वर्ग कि.मी.)",
            //     valueEnglish: "110.16 (sq. Km.)",
            //     class: "col-md-12",
            // },
            {
                key: " वडा संख्या",
                keyEnglish: "ward",
                value: "७",
                valueEnglish: "7",
                class: "col-md-12",
            },
            // {
            //     key: "अक्षांश तथा देशान्तर",
            //     keyEnglish: "latitude and longitude",
            //     value: "२६.६२८६८ , ८७.३४०४१",
            //     valueEnglish: "26.62868 , 87.34041",
            //     class: "col-12",
            // },
            // {
            // 	key: "मुख्य सहरी क्षेत्र",
            // 	keyEnglish: "Main city area",
            // 	value: "",
            // 	class: "col-12",
            // },
        ];
        this.setState({ ...this.state, boundData });
    }
    getMunicipalBounds() {
        let modalClose = () => this.setState({ modalShow: false });
        return (
            <div className="col-lg-5 pb-5 d-flex">
                <Card>
                    <Card.Body>
                        <div className="d-flex pb-8">
                            <SVG
                                className="primary-icon"
                                src={toAbsoluteUrl(
                                    "media/hamropalika/svg/map_marker.svg"
                                )}
                                alt=""
                            />
                            <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                {this.props.selectedLanguage == "nepali"
                                    ? "सिमाना"
                                    : "Boundaries"}
                            </h2>
                        </div>
                        <div className="row">
                            {this.state.boundData.map((data, index) => {
                                return (
                                    <div
                                        className={`pb-3 ${data.class}`}
                                        key={index}
                                    >
                                        <div className="row">
                                            <div className="col-4">
                                                <h5 className="pr-2">
                                                    {this.props
                                                        .selectedLanguage ==
                                                    "nepali"
                                                        ? data.key
                                                        : data.keyEnglish}
                                                    :
                                                </h5>
                                            </div>
                                            <div className="col-8">
                                                <h5 className="text-primary">
                                                    {this.props
                                                        .selectedLanguage ==
                                                    "nepali"
                                                        ? data.value
                                                        : data.valueEnglish}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="float-right ">
                            <Button
                                className="px-10 emergency-button text-danger"
                                variant="light-danger"
                                size="lg"
                                onClick={() =>
                                    this.setState({ modalShow: true })
                                }
                            >
                                {" "}
                                <i className="icon-emergency"></i>{" "}
                                {this.props.selectedLanguage == "nepali"
                                    ? "आपतकालीन सम्पर्क"
                                    : "Emergency Contact"}
                            </Button>
                            {/* 
							<EmergencyContactModal
								selectedLanguage={this.props.selectedLanguage}
								show={this.state.modalShow}
								onHide={modalClose}
							/> */}
                        </div>
                    </Card.Body>
                </Card>
            </div>
        );
    }
    getMunicpalId() {
        return (
            <div className="col-lg-12 pb-5 d-flex ">
                <Card>
                    <Card.Body>
                        <div className="d-flex pb-8">
                            <SVG
                                className="primary-icon"
                                src={toAbsoluteUrl(
                                    "media/hamropalika/svg/municipality_id.svg"
                                )}
                                alt=""
                            />
                            <h2 className=" pl-3 pt-6 homepage-heading">
                                {this.props.selectedLanguage == "nepali"
                                    ? "गाउँपालिका अबस्थित  नक्शा"
                                    : "Rural Municipality Location Map"}
                            </h2>
                        </div>

                        <h4 className="col-lg-6 pb-5 d-flex">
                            {this.props.selectedLanguage === "nepali" ? "" : ""}
                        </h4>

                        {/* <div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div> */}
                        <div className="col-lg-5 pb-5 d-flex">
                            <div className="row">
                                {this.state.boundData.map((data, index) => {
                                    return (
                                        <div
                                            className={`pb-3 ${data.class}`}
                                            key={index}
                                        >
                                            <div className="row">
                                                <div className="col-4">
                                                    <h5 className="pr-2">
                                                        {this.props
                                                            .selectedLanguage ==
                                                        "nepali"
                                                            ? data.key
                                                            : data.keyEnglish}
                                                        :
                                                    </h5>
                                                </div>
                                                <div className="col-8">
                                                    <h5 className="text-primary">
                                                        {this.props
                                                            .selectedLanguage ==
                                                        "nepali"
                                                            ? data.value
                                                            : data.valueEnglish}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/* <img
							className="w-100"
							src={toAbsoluteUrl("/media/hamropalika/bhotekoshiStatic.png")}
							alt=""
						/> */}
                    </Card.Body>
                </Card>
            </div>
        );
    }
    render() {
        return (
            <>
                <Card>
                    <Card.Body>
                        <Card.Title className="d-md-flex justify-space-between row">
                            <div className="d-flex col-md-6">
                                <SVG
                                    className="primary-icon"
                                    style={{ width: "32px" }}
                                    src={toAbsoluteUrl(
                                        "media/hamropalika/svg/municipality_id.svg"
                                    )}
                                    alt=""
                                />
                                <h2 className="font-weight-black pl-3 pt-5 homepage-heading">
                                    {this.props.selectedLanguage == "nepali"
                                        ? "गाउँपालिका संक्षिप्त परिचय"
                                        : "Rural Municipality Brief introduction"}
                                </h2>
                            </div>
                            <div id="destination">
                                <h2 className="font-weight-black pl-3 pt-5 homepage-heading">
                                    <MdPlace
                                        id="destination-icon"
                                        style={{ width: "32px" }}
                                    />{" "}
                                    {this.props.selectedLanguage == "nepali"
                                        ? "पर्यटकीय तथा महत्वपूर्ण स्थान"
                                        : "Tourist and important places"}
                                </h2>
                            </div>
                        </Card.Title>
                        <Card.Text>
                            <div className="row">
                                <div className="col-md-12 d-md-flex ">
                                    <div
                                        className="col-md-6 text-justify"
                                        id="intro-para"
                                    >
                                        <h4>
                                            {this.props.selectedLanguage ===
                                            "nepali"
                                                ? "मोरङ जिल्लाका १७ वटा स्थानीय तहहरु मध्ये ग्रामथान गाउँपालिका जिल्लाको दक्षिण – पश्चिमी भागमा पर्दछ । यस गाउँपालिकामा केही उधोग धन्दा पनि रहेका छन् । यस गाउँपालिकाको मध्य भाग हुँदै विराटनगर विराटचौक सडक गएको छ । जसले दक्षिणमा विराटनगर र उत्तरमा पूर्व – पश्चिम राजमार्गसँग सम्पर्क गराउन महत्वपूर्ण भूमिका खेलेको छ । कूल क्षेत्रफल ७१.८४ वर्ग कि.मी मा फैलिएको यस गाउँपालिकामा ९३७७ घरधुरी र ३६०२४ जनसंख्या रहेको  छ । गाउँपालिकामा जम्मा ७ वटा वडाहरु रहेका छन् । यस गाउँपालिकाको कूल साक्षरता दर ७२.६% रहेको छ । समुद्र सतहबाट ७३ मिटर उचाइमा रहेको यस गाउँपालिकामा करिव ८० % कृषियोग्य र गैर कृषि क्षेत्रको जमिन करिब २० % रहेको छ ।"
                                                : ""}
                                        </h4>
                                    </div>
                                    <div className="d-flex pb-8 d-sm-block d-md-none col-md-6 justify-content-start">
                                        <h2 className="font-weight-black pl-3 pt-5 homepage-heading text-left">
                                            <MdPlace
                                                id="destination-icon"
                                                style={{ width: "32px" }}
                                            />{" "}
                                            {this.props.selectedLanguage ==
                                            "nepali"
                                                ? "पार्यटकीय तथा महत्वपूर्ण स्थान"
                                                : "Tourist and important places"}
                                        </h2>
                                    </div>
                                    <div className="col-md-6 overflow-auto">
                                        {/* <div className="card-content text-justify">
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/baagghodapokhari.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "बाघझोडा पोखरी सिमसार क्षेत्र"
                                                                : "Tigerhorse Pond Wetland"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वडा नम्बर १०मा अवस्थित  बाघझोडा सिमसार सुन्दरहरैँचा नगरको खोर्साने बजारबाट करिब एक किलोमिटर उत्तर लागेपछि पुगिन्छ। व्यवस्थित सडकमा साना सवारीसाधन प्रशस्तै पाइने भएकाले यहाँ सजिलै पुग्न सकिन्छ | यस बाघझोडा सिमसार पोखरीको क्षेत्रफल करिब ७ विघा ५ कट्ठा १२ धुर रहेको छ | पोखरी बाहेक उत्तर तिर करी १० बिघा बन क्षेत्र भित्र पानि रसाएर आउने सिमसार भूभाग रहेको छ | वि.स. २०३६ साल अघि यस आसपास क्षेत्रमा बाघ पाइने र यस क्षेत्रमा बाघ पानी पिउन आउने हुनाले त्यसका आधारमा यस सिमसारको नाम बाघझोडा रहेको भन्ने स्थानीय जनाताको भनाई रहेको पाइन्छ |  यस क्षेत्र प्राकृतिक तथा जैविक विविधताले भरिपूर्ण रहेको छ | यस क्षेत्रमा विभिन्न दुर्लब चराचुरुङ्गीहरू र सरिसृपहरु पाइन्छ | यस बाघझोडा क्षेत्रमा धार्मिक मन्दिर तथा खेल मैदान पनि रहेको छ |"
                                                            : "BagGodha Wetland located in Ward No. 10 is reached after about one kilometer north from Khorsane Bazar in Sundarharaincha Nagar. It is easy to reach here as there are plenty of small vehicles on the well-maintained roads The area of ​​this BagGodhawetland is about 7 bigha 5 katha 12 dhur Apart from the pond, there is a wetland in the north of the 10 bigha forest area B.S. Before 2036 years ago, tigers were found in this area and tigers used to come to drink water in this area, so the name of this wetland is BagGodha"}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/kichkandi.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div
                                                    className="card-body"
                                                    id="card-body"
                                                >
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "किचकगढी सिमसार"
                                                                : "Kichkagarhi Wetlands"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left overflow-hidden">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वडा नम्बर १ डागी टोल (मदन आश्रित मार्ग देखि लक्षिण लक्ष्मीपुर सम्म) मा पर्ने यस किचकगढी सिमसार क्षेत्र ऐतिहासिक पुरातात्विक र धार्मिक गढीको रुपमा परिचित रहेको छ | यस क्षेत्र महाभारतमा किच्चकलाई वध गरेको ठाउँ भएको भन्ने किम्बदन्तिमा उल्लेख रहेको भनाई स्थानीयको रहेको छ | हरेक वर्ष यस स्थानमा वैशाख १४ गते परम्परागत पूजनोत्सव सहित मेला लाग्ने गरेको छ | हाल यो गढी साँगुरो र होचो हुँदै गएको छ । गढी वरिपरिका जलाशय तथा धापहरु पूरा समाप्त भई सुख्खा खेती योग्य जमिनमा परिणत हुँदै गएका, पुराना र ठूला रुखहरु सम्पूर्ण काटिई उजाड भएका छन् ।यस महत्वपूर्ण स्थानको संरक्षण तथा यस गढीको महत्वलाई उजागर गर्न यसको विकास र प्रवद्र्धन गर्न जरुरि देखिन्छ |"
                                                            : "This Kichkagarhi Wetland located in Ward No. 1 Dagi Toll (from Madan Ashrit Marg to Lakshin Lakshmipur) is known as a historical archaeological and religious site. Locals say that this area is the place where Kichchak was killed in the Mahabharata. Every year, a fair is held at this place on the 14th of Baisakh along with the traditional worship festival Currently, this fort is getting narrower and narrower. The reservoirs and dhaps around the fort have been completely depleted and converted into dry arable land, old and large trees"}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/hasinaSimsar.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "हसिना सिमसार "
                                                                : "Hasina Wetlands"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वडा नम्बर ५ हसिना टोलमा अवस्थित यस हसिना सिमसार ४९ हेक्टर क्षेत्रमा फैलिएको छ | झट्ट हेर्दा पहाडका ससाना थुम्काहरू रहेको ठाउँजस्तो देखिने हसिना सिमसार क्षेत्र पहाड नभएर एउटा झोडा क्षेत्र हो।  सिमसार क्षेत्रमा बुद्ध बिहार, बुद्ध पोखरी, बुढासुब्बा मन्दिर, नाग पोखरी, साकेला थान, शिवालय मन्दिर आदि धार्मिक क्षेत्रहरु पनि बनाइएको छ  | यस क्षेत्रमा धार्मिक पर्यटकहरुको पनि आकर्षक गन्तव्य बन्दै गएको छ |  बहुसङ्ख्यक देवीदेवताका मन्दिर, विभिन्न प्रजातिका वनस्पति, जीवजन्तु, र पशुपन्छीको बासस्थानसमेत रहेको सो क्षेत्र पर्यटकीय क्षेत्र मात्र नभै वनभोज, अध्ययन–अनुसन्धान र अवलोकनका लागिसमेत उत्तिकै उपयोगी रहेको छ । मिनि जु, विभिन्न कलाकृति र ६ वटा सानाठूला पोखरीले पनि हसिनाको आकर्षण बढाएको छ ।यस क्षेत्रमा बँदेल, मृग, दुम्सी, खरायो, वनकुखुरा, सिमकुखुरा र बाँदर लगायत विभिन्न जातका बन्यजन्तु तथा पशुपन्क्षीहरू पाइन्छन्।"
                                                            : "Located in Ward No. 5 Hasina Tol, this Hasina Wetland is spread over an area of ​​49 hectares At first glance, the Hasina wetlands, which look like small hillocks, are not mountains, but a scrubland. Religious areas such as Buddha Bihar, Buddha Pond, Budhasubba Temple, Nag Pond, Sakela Than, Shivalaya Temple etc. have also been built in the wetland area. This area is also becoming an attractive destination for religious tourists There are many temples of Gods and Goddesses, various species of plants, animals, and animals Different species of wild animals and birds including wild boar, deer, cow, rabbit, forest fowl, guinea fowl and monkey are found in this area."}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/nayaVrindavan.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "नयाँ वृन्दावन गौशालाः सुन्दरहरैंचा "
                                                                : "New Vrindavan Gaushala: Sundarharaicha"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "धार्मिक पर्यटन क्षेत्रको विकास प्रवर्द्धन प्रचारप्रसार गर्ने हेतुले यो वृन्दावन गौशाला सुन्दरहरैचा नगरपालिका वडा नम्बर ५ बुढीखोलातर्फ निर्माण गरिदै छ | द्वापरयुगमा भगवान् श्रीकृष्णले आफ्नो कृष्णलीला देखाएको पवित्र तीर्थस्थल वृन्दावन गौशालालाई सचित्ररूपमा जस्ताको त्यस्तै निर्माण गर्ने अभियान नयाँ वृन्दावन गौशालामा थालनी गरिएको छ   |  चार कठ्ठा जमिनबाट निर्माण सुरु गरिएको यो धार्मिकग्राम अहिले सात बिघाभन्दा बढी क्षेत्रफलमा पुगिसकेको छ भने सो क्षेत्रमा नेपालकै ठूलो राधाकृष्णको मन्दिरको निर्माण भइरहेको छ र विश्वकै ठूलो गाईको प्रतिमा निर्माण गर्न डीपीआर तयार भएको छ । अहिले निर्माण भइरहेको नयाँ वृन्द्रावन गौशालामा हाल गाई र बाच्छाबाच्छीसमेत संरक्षण गरिएको छ भने नदी नियन्त्रणका लागि वृक्षरोपणका कामहरूसमेत भएका छन् । नयाँ वृन्दावन गौशालामा गाईको विशाल प्रतिमा स्थापित गरिएको छ |"
                                                            : "This Vrindavan Cowshed is being constructed towards Sundararaicha Municipality Ward No. 5 Budhikhola in order to promote the development of religious tourism sector. In the Dwapara Yuga, the campaign to build the holy shrine Vrindavan Gaushala, where Lord Krishna performed his Krishna Leela, has been started in New Vrindavan Gaushala. The construction of this religious village, which was started from four acres of land, has now reached an area of ​​more than seven bighas, and the largest Radhakrishna temple in Nepal is being built in that area."}
                                                    </p>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </Card.Text>
                    </Card.Body>
                </Card>
                <CardGroup id="card-group">
                    <Card className="col-lg-6 d-flex">
                        <Card.Body id="card-body">
                            <Card.Title id="card-title">
                                <div className="d-flex pb-2" id="map-icon">
                                    <SVG
                                        className="primary-icon"
                                        src={toAbsoluteUrl(
                                            "media/hamropalika/svg/map_marker.svg"
                                        )}
                                        alt=""
                                    />
                                    <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                        {this.props.selectedLanguage == "nepali"
                                            ? "गाउँपालिका अबस्थित नक्शा"
                                            : "Boundaries"}
                                    </h2>
                                </div>
                            </Card.Title>
                            <Card.Text>
                                <img
                                    // style={{ height: "50px", width: "100%" }}
                                    className="w-10"
                                    style={{ maxWidth: "350px" }}
                                    src={toAbsoluteUrl(
                                        "/media/hamropalika/gramthan.jpg"
                                    )}
                                    alt=""
                                />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="col-lg-6 pb-5 d-flex">
                        <Card.Body id="card-body">
                            <Card.Title>
                                <div className="d-flex pb-2 " id="map-icon">
                                    <SVG
                                        className="primary-icon"
                                        src={toAbsoluteUrl(
                                            "media/hamropalika/svg/map_marker.svg"
                                        )}
                                        alt=""
                                    />
                                    <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                        {this.props.selectedLanguage == "nepali"
                                            ? "सिमाना"
                                            : "Boundaries"}
                                    </h2>
                                </div>
                            </Card.Title>
                            <Card.Text>
                                <div className="row">
                                    {this.state.boundData.map((data, index) => {
                                        return (
                                            <div
                                                className={`pb-2 ${data.class}`}
                                                key={index}
                                            >
                                                <div className="row">
                                                    <div className="col-4">
                                                        <h5 className="pr-2 text-left simana-data">
                                                            {this.props
                                                                .selectedLanguage ==
                                                            "nepali"
                                                                ? data.key
                                                                : data.keyEnglish}
                                                            :
                                                        </h5>
                                                    </div>
                                                    <div className="col-8">
                                                        <h5 className="text-primary text-left">
                                                            {this.props
                                                                .selectedLanguage ==
                                                            "nepali"
                                                                ? data.value
                                                                : data.valueEnglish}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    {/* {this.getMunicpalId()} */}
                    {/* {this.getMunicipalBounds()} */}
                </CardGroup>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MunicipalityDescription);
